import apiService from './api-service';

export const fuelDepoService = {
	getFuelDepos
};

async function getFuelDepos() {
	const result = await apiService.get('fueldepo/getFuelDepos');

	return result;
}
